import { render, staticRenderFns } from "./BillsLinkShare.vue?vue&type=template&id=04751934&scoped=true"
import script from "./BillsLinkShare.vue?vue&type=script&lang=js"
export * from "./BillsLinkShare.vue?vue&type=script&lang=js"
import style0 from "./BillsLinkShare.vue?vue&type=style&index=0&id=04751934&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04751934",
  null
  
)

export default component.exports